import { HOST_URL } from "../constants/index";
import axios from "axios";

export const encodeData = (data) => {
  return Object.keys(data)
    .map((key) => `${key}=${encodeURIComponent(data[key])}`)
    .join("&");
};

export default axios.create({
  validateStatus: (status) => status < 400,
  baseURL: HOST_URL,
  headers: {
    "content-type": "application/x-www-form-urlencoded",
    // Authorization: `Bearer ${accessToken}`,
  },
});
